<div class="route-component">
    <div class="search-component">
        <h4>
             Matching
        </h4>

        <div class="line-connector"></div>

        <div class="action-bar">
            <div class="action-bar right">
                <div class="action-container">
                    <button *hasPermission="['Matching', 'Matching']" type="button" class="button" (click)="createMatchingBatch()">
                        Auto-Map Data
                    </button>
                </div>
            </div>
        </div>

        <div class="search-bar">
            <div class="search-bar left">
                <div class="search-container">

                    <auto-complete-dropdown
                        [type]="'status'"
                        [options]="statusOptions"
                        [initialValue]="selectedStatus ? 1 : 0"
                        [displayWith]="displayStatus"
                        (selectionChange)="onStatusSelectionChange($event)">
                    </auto-complete-dropdown>

                    <auto-complete-dropdown
                        *ngIf="selectedPeriodId"
                        [type]="'period'"
                        [options]="periods"
                        [placeholder]="'Select a period...'"
                        [initialValue]="selectedPeriodId"
                        [displayWith]="formatPeriod"
                        (selectionChange)="onPeriodSelectionChange($event)">
                    </auto-complete-dropdown>

                    <input class="search-input" type="text" placeholder="Search..." [(ngModel)]="search" (keydown.enter)="getMatchingBatches(paging)" [ngModelOptions]="{standalone: true}">

                    <button class="search-button" (click)="getMatchingBatches(paging)">
                        <i class="fas fa-magnifying-glass"></i>
                    </button>

                </div>
            </div>
        </div>

        <pageable-table
            [items]="batches"
            [paging]="paging"
            [columns]="getColumnMap()"
            (refreshData)="getMatchingBatches($event)"
            [showEdit]="showEdit"
            (editItem)="editMatchingBatch($event)"
            [showDelete]="showDelete"
            (deleteItem)="deleteMatchingBatch($event)">
        </pageable-table>
    </div>
</div>